import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import { CredentialApplicationDefinitionType } from '../../models/credential/CredentialApplicationDefinitionType';
import { TeamScenarioReportModel } from 'src/app/reports/credential-scenario-report/team-scenario-report.model';
import { BaseCredentialApplicationReportModel } from './base-credential-application-report.model';

export class TeamCredentialApplicationReportModel extends BaseCredentialApplicationReportModel {
  public teamId: string;
  public teamCredentialId: string;
  public name: string;
  public publicName: string;
  public scenarios: TeamScenarioReportModel[] = [];
  public systemStatus: string;
  public workspaceName: string;

  static parse(data: any): TeamCredentialApplicationReportModel {
    if (!data) return null;
    let model = new TeamCredentialApplicationReportModel();
    Object.assign(model, data);

    if (data.credentialApplicationType == CredentialApplicationDefinitionType.Initial) {
      model.credentialApplicationType = 'New Credential';
    }
    return model;
  }
}

export class TeamCredentialApplicationReportFilterResult implements FilterResult {
  public count: number;
  public values: any[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new TeamCredentialApplicationReportFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((report) =>
      TeamCredentialApplicationReportModel.parse(report)
    );
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
